module.exports = __webpack_public_path__ + "img/148.689365b0.jpg";